import { render, staticRenderFns } from "./AddonUpsellModal.vue?vue&type=template&id=8a7fe896&"
import script from "./AddonUpsellModal.vue?vue&type=script&lang=js&"
export * from "./AddonUpsellModal.vue?vue&type=script&lang=js&"
import style0 from "./AddonUpsellModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddonUpsellModal.vue"
export default component.exports